import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { softwareReportsControlEntrypoint } from '@atlassian/jira-spa-apps-software-reports-control-report/src/entrypoint.tsx';

export const softwareReportsControlPageEntrypoint = createPageEntryPoint({
	main: softwareReportsControlEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
